import React from 'react'
import style from '../style'
import propTypes from '../prop'
import ClassNames from 'classnames'
import { withStyles, TableCell } from '@material-ui/core'
import { CoreIconButton } from 'src/components/core'
import { Icon } from '@iconify/react'

/**
 *
 * @param {*} props
 */
const ListContainerColumnExpanded = props => {
  const { classes, expanded, changeExpanded, entity, disabled } = props

  /**
   *
   * @param {*} event
   */
  const handleOnClick = event => {
    changeExpanded(entity.id)
  }

  return (
    <TableCell className={ClassNames(classes.root, classes.expandedColumn)}>
      <CoreIconButton
        disabled={disabled}
        onClick={handleOnClick}
        color="primary"
        variant="text"
        size="small"
        className={ClassNames(classes.expand, {
          [classes.expanded]: expanded,
        })}
        aria-expanded={expanded}
      >
        <Icon icon="ic:round-expand-more" />
      </CoreIconButton>
    </TableCell>
  )
}

ListContainerColumnExpanded.propTypes = propTypes

export default withStyles(style)(ListContainerColumnExpanded)
